// colors
export const BLUE_PLOOT = "#416ce1";
export const BLUE_BUTTON = "#416ce1";
export const BLUE_PLOOT_1 = "#094392";
export const GREEN_PLOOT = "#34d86a";
export const GREEN_PLOOT_1 = "#41d287";
export const GREEN_BUTTON = "#52da9c";
export const DRAK_GREEN_PLOOT = "#1bad53";
export const RED_PLOOT = "#e4747a";
export const DARK_RED_PLOOT = "#f25f5f";
export const RED_1 = "#f74747";
export const DANGER_RED = "#d34a4a";
export const WHITE = "#fff";
export const OFF_WHITE = "#f1f1f1";
export const DISABLED_PICKER = "#f6f6f6";
export const BLACK = "#000";
export const TEXT_BLACK = "#404a57";
export const TEXT_BLACK_1 = "#2b2d38";
export const TEXT_BLACK_2 = "#919191";
export const TEXT_BLACK_3 = "#535353";
export const GREY = "grey";
export const GREY_1 = "#707070";
export const GREY_2 = "#989b9f";
export const GREY_DARK = "#888";
export const TEXT_GREY = "#777777";
export const TEXT_GREY_1 = "#9f9f9f";
export const LIGHT_GREY = "#f8f8f8";
export const LIGHT_GREY_1 = "#efefef";
export const PLACEHOLDER_GREY = "#7b7c83";
export const DISABLE_GREY = "#bcbec6";
export const TRANSPARENT = "rgba(0,0,0,0)";
export const BORDER_COLOR = "#c6cbde";
export const BORDER_1 = "#ddd";
export const BORDER_2 = "#72768c";
// Temporary
export const color_pallete = [
    // "#3E68D9",
    "#5A60CC",
    "#000060",
    "#41D287",
    "#05BCBC",
    "#045F60",
    "#43B53F",
    "#F25F5F",
    "#A60F0B",
    "#FE4F06",
    "#F25F5F",
    "#672C3F",
    "#B11F52",
    "#DB516C",
    // "#3E68D9",
    // "#41D287",
    // "#000060",
    // "#F25F5F",
    // "#5A60CC",
    // "#05BCBC",
    // "#045F60",
    // "#43B53F",
    // "#F25F5F",
    // "#A60F0B",
    // "#FE4F06",
    // "#672C3F",
    // "#B11F52",
    // "#DB516C",
    // ********************
    "#3E68D9",
    "#5A60CC",
    "#7550AE",
    "#000060",
    "#005C91",
    "#352A58",
    "#423E83",
    "#209ADB",
    "#293DAC",
    // '#98527D',
    // '#80D3FF',
    // '#41D287',
    // '#78E6C1',
    // '#A0D928',
    // '#05BCBC',
    // '#2A5165',
    // '#045F60',
    // '#329587',
    // '#43B53F',
    // '#8CAD31',
    // '#AD9D09',
    // '#BEE588',
    // '#F25F5F',
    // '#672C3F',
    // '#A60F0B',
    // '#B11F52',
    // '#DB516C',
    // '#9B3014',
    // '#D00000',
    // '#FE4F06',
    // '#7B2711',
    // '#BD4800',
    // '#F7D700',
    // '#E79311',
    // '#F4C764',
    // '#FF741D',
    // '#ffb507',
    // '#CEAE05',
    // '#FCB273',
    // '#966C51',
    // '#B672F0',
    // '#E389F4',
    // '#EB7FC2',
    // '#E09269',
    // '#71673D',
    // '#88C1A7',
];
